<template>
  <el-row class="container">
    <el-col :offset="4" :span="16">
      <logo :title="title" :primary-color="primaryColor"></logo>
      <form v-if="state === 'reset'" @submit.prevent="submit">
        <p>To reset your password, enter a new password below.</p>
        <table role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0" align="center" style="margin: auto; width:90%;">
          <tr>
            <td style="text-align: left;font-weight: bold;padding: 1.2em 0.8em;" class="">
              NEW PASSWORD<br>
              <input v-model="pw_new1" class="input password-input" placeholder="Enter your new password" type="password" style="margin: auto; width:90%;border-style: none none solid none;border-bottom-color:rgb(210, 210, 210);">
            </td>
          </tr>
          <tr>
            <td style="text-align: left;font-weight: bold;padding: 1.2em 0.8em;" class="">
              RETYPE NEW PASSWORD<br>
              <input v-model="pw_new2" class="input password-input" placeholder="Retype your new password" type="password" style="margin: auto; width:90%;border-style: none none solid none;border-bottom-color:rgb(210, 210, 210);">
            </td>
          </tr>
          <tr>
            <td v-if="reset_error1" class="reset_error">
              <h3 style="margin: 0;">Password too short or too long.</h3>
              Passwords must be between 8-20 characters.
            </td>
          </tr>
          <tr>
            <td v-if="reset_error2" class="reset_error">
              <h3 style="margin: 0;">Passwords not matching.</h3>
              Make sure your new passwords match.
            </td>
          </tr>
          <tr>
            <td v-if="reset_error3" class="reset_error">
              <h3 style="margin: 0;">Server error.</h3>
              Please try again later.
            </td>
          </tr>
        </table>
        <button type="submit" :style="{background: primaryColor, 'border-color': primaryColor}">Reset Password</button>
      </form>
      <p v-if="state === 'expired'">Your link expires after 24 hours or once a new password is set. If you still wish to reset your password, please use the mobile app to request a new password reset link.</p>
      <p v-if="state === 'done'">Please reopen the myProduct app and try logging into your account.</p>
      <company :name="footer.companyName" :url="footer.companyUrl" :address="footer.companyAddress" :contact="footer.companyContact" :primary-color="primaryColor"></company>
    </el-col>
  </el-row>
</template>

<script>
  import main from './Reset.js'
  export default main
</script>

<style lang="scss" scoped>
  @import '../variable.scss';
  @import '../style.scss';
  @import './Reset.scss';
</style>



// WEBPACK FOOTER //
// Reset.vue?3c57b9fc